import { icons } from "utils/constants";
import { useDispatch } from "react-redux";
import { setShowSubscriptionPopup } from "store/globalSlice";
import "./SubscriptionButton.scss";

const SubscriptionButton = () => {
  const dispatch = useDispatch();
  return (
    <div
      id="subscriptionbutton-container"
      onClick={() => {
        dispatch(setShowSubscriptionPopup(true));
      }}
    >
      <span className="h-20 d-flex">
        <img src={icons.crown} alt="crown" className="fit-image" />
      </span>
      <span className="text-16-600 pt-1">Subscription</span>
    </div>
  );
};

export default SubscriptionButton;
